if(!Util) { function Util () {} };

Util.hasClass = function(el, className) {
  return el.classList.contains(className);
};

Util.addClass = function(el, className) {
  var classList = className.split(' ');
  el.classList.add(classList[0]);
  if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
};

Util.removeClass = function(el, className) {
  var classList = className.split(' ');
  el.classList.remove(classList[0]);
  if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(' '));
};

Util.moveFocus = function (element) {
  if( !element ) element = document.getElementsByTagName('body')[0];
  element.focus();
  if (document.activeElement !== element) {
    element.setAttribute('tabindex','-1');
    element.focus();
  }
};


// File#: _1_drawer
// Usage: codyhouse.co/license
(function() {
	var Drawer = function(element) {
		this.element = element;
		this.content = document.getElementsByClassName('js-drawer__body')[0];
		this.triggers = document.querySelectorAll('[aria-controls="'+this.element.getAttribute('id')+'"]');
		this.firstFocusable = null;
		this.lastFocusable = null;
		this.selectedTrigger = null;
		this.isModal = Util.hasClass(this.element, 'js-drawer--modal');
		this.showClass = "drawer--is-visible";
		this.preventScrollEls = this.getPreventScrollEls();
		this.initDrawer();
	};

	function normalizePathname(pathname) {
		if(!pathname) return '/';
		// treat "/foo" and "/foo/" as the same path
		return pathname.replace(/\/+$/, '') || '/';
	}

	function getSamePageHashFromLink(linkEl) {
		if(!linkEl || !linkEl.getAttribute) return null;
		if(linkEl.hasAttribute('download')) return null;
		if(linkEl.target && linkEl.target !== '_self') return null;
		var rawHref = linkEl.getAttribute('href');
		if(!rawHref) return null;
		// ignore non-navigation protocols
		if(/^(mailto:|tel:|sms:|javascript:)/i.test(rawHref.trim())) return null;

		var url;
		try {
			url = new URL(rawHref, window.location.href);
		} catch(e) {
			return null;
		}
		if(!url.hash || url.hash.length < 2) return null;
		if(url.origin !== window.location.origin) return null;

		var samePath = normalizePathname(url.pathname) === normalizePathname(window.location.pathname);
		var sameSearch = url.search === window.location.search;
		if(!(samePath && sameSearch)) return null;

		return url.hash;
	}

	Drawer.prototype.getPreventScrollEls = function() {
		var querySelector = this.element.getAttribute('data-drawer-prevent-scroll');
		if(!querySelector) return [];
		return Array.prototype.slice.call(document.querySelectorAll(querySelector));
	};

	Drawer.prototype.initDrawer = function() {
		var self = this;
		//open drawer when clicking on trigger buttons
		if ( this.triggers ) {
			for(var i = 0; i < this.triggers.length; i++) {
				this.triggers[i].addEventListener('click', function(event) {
					event.preventDefault();
					if(Util.hasClass(self.element, self.showClass)) {
						self.closeDrawer(event.target);
						return;
					}
					self.selectedTrigger = event.target;
					self.showDrawer();
					self.initDrawerEvents();
				});
			}
		}

		// if drawer is already open -> we should initialize the drawer events
		if(Util.hasClass(this.element, this.showClass)) this.initDrawerEvents();
	};

	Drawer.prototype.showDrawer = function() {
		var self = this;
		this.content.scrollTop = 0;
		Util.addClass(this.element, this.showClass);
		this.getFocusableElements();
		Util.moveFocus(this.element);
		// wait for the end of transitions before moving focus
		this.element.addEventListener("transitionend", function cb(event) {
			Util.moveFocus(self.element);
			self.element.removeEventListener("transitionend", cb);
		});
		this.emitDrawerEvents('drawerIsOpen', this.selectedTrigger);

		// stop Lenis smooth scrolling while drawer is open
		if(window.lenis && typeof window.lenis.stop === 'function' && typeof window.lenis.start === 'function') {
			if(!window.lenis.isStopped) {
				window.lenis.stop();
				this.element.dataset.drawerLenisStopped = 'true';
			}
		}

		// change the overflow of the preventScroll elements
		if(this.preventScrollEls.length > 0) {
			for(var i = 0; i < this.preventScrollEls.length; i++) {
				var el = this.preventScrollEls[i];
				el.dataset.drawerPrevOverflow = el.style.overflow || '';
				el.style.overflow = 'hidden';
			}
		}
	};

	Drawer.prototype.closeDrawer = function(target) {
		Util.removeClass(this.element, this.showClass);
		this.firstFocusable = null;
		this.lastFocusable = null;
		if(this.selectedTrigger) this.selectedTrigger.focus();
		//remove listeners
		this.cancelDrawerEvents();
		this.emitDrawerEvents('drawerIsClose', target);

		// restore Lenis smooth scrolling (only if it was stopped by this drawer)
		if(this.element.dataset.drawerLenisStopped === 'true' && window.lenis && typeof window.lenis.start === 'function') {
			window.lenis.start();
			delete this.element.dataset.drawerLenisStopped;
		}

		// restore overflow of the preventScroll elements
		if(this.preventScrollEls.length > 0) {
			for(var i = 0; i < this.preventScrollEls.length; i++) {
				var el = this.preventScrollEls[i];
				el.style.overflow = el.dataset.drawerPrevOverflow || '';
				delete el.dataset.drawerPrevOverflow;
			}
		}
	};

	Drawer.prototype.initDrawerEvents = function() {
		//add event listeners
		this.element.addEventListener('keydown', this);
		this.element.addEventListener('click', this);

		// global listeners (robust close on Esc / outside click)
		if(!this.onDocumentKeydown) {
			this.onDocumentKeydown = function(event) {
				if( !Util.hasClass(this.element, this.showClass) ) return;
				if( (event.key && event.key === 'Escape') || (event.keyCode && event.keyCode === 27) ) {
					event.preventDefault();
					this.closeDrawer(false);
				}
			}.bind(this);
		}

		if(!this.onDocumentClick) {
			this.onDocumentClick = function(event) {
				if( !Util.hasClass(this.element, this.showClass) ) return;

				// ignore clicks on triggers controlling this drawer
				var trigger = event.target.closest && event.target.closest('[aria-controls="'+this.element.getAttribute('id')+'"]');
				if(trigger) return;

				// close on click outside drawer content
				var clickedInsideContent = event.target.closest && event.target.closest('.drawer__content');
				if(clickedInsideContent) return;

				event.preventDefault();
				this.closeDrawer(event.target);
			}.bind(this);
		}

		document.addEventListener('keydown', this.onDocumentKeydown, true);
		document.addEventListener('click', this.onDocumentClick, true);
	};

	Drawer.prototype.cancelDrawerEvents = function() {
		//remove event listeners
		this.element.removeEventListener('keydown', this);
		this.element.removeEventListener('click', this);

		if(this.onDocumentKeydown) document.removeEventListener('keydown', this.onDocumentKeydown, true);
		if(this.onDocumentClick) document.removeEventListener('click', this.onDocumentClick, true);
	};

	Drawer.prototype.handleEvent = function (event) {
		switch(event.type) {
			case 'click': {
				this.initClick(event);
			}
			case 'keydown': {
				this.initKeyDown(event);
			}
		}
	};

	Drawer.prototype.initKeyDown = function(event) {
		if( event.keyCode && event.keyCode == 27 || event.key && event.key == 'Escape' ) {
			//close drawer window on esc
			this.closeDrawer(false);
		} else if( this.isModal && (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab' )) {
			//trap focus inside drawer
			this.trapFocus(event);
		}
	};

	Drawer.prototype.initClick = function(event) {
		// close drawer on same-page anchor navigation so scrolling is not blocked after the jump
		var link = event.target.closest && event.target.closest('a[href]');
		if(link) {
			var hash = getSamePageHashFromLink(link);
			if(hash) {
				var targetId;
				try {
					targetId = decodeURIComponent(hash.replace('#', ''));
				} catch(e) {
					targetId = hash.replace('#', '');
				}
				var target = document.getElementById(targetId);
				if(target) {
					event.preventDefault();
					this.closeDrawer(link);

					window.requestAnimationFrame(function() {
						if(window.location.hash !== hash) {
							history.pushState(false, false, hash);
						}
						target.scrollIntoView();
					});
					return;
				}
			}
		}

		// close drawer when clicking outside drawer content (overlay / page behind)
		var clickedInsideContent = event.target.closest && event.target.closest('.drawer__content');
		if(!clickedInsideContent) {
			event.preventDefault();
			this.closeDrawer(event.target);
			return;
		}

		//close drawer when clicking on close button
		if( !event.target.closest('.js-drawer__close') ) return;
		event.preventDefault();
		this.closeDrawer(event.target);
	};

	Drawer.prototype.trapFocus = function(event) {
		if( this.firstFocusable == document.activeElement && event.shiftKey) {
			//on Shift+Tab -> focus last focusable element when focus moves out of drawer
			event.preventDefault();
			this.lastFocusable.focus();
		}
		if( this.lastFocusable == document.activeElement && !event.shiftKey) {
			//on Tab -> focus first focusable element when focus moves out of drawer
			event.preventDefault();
			this.firstFocusable.focus();
		}
	}

	Drawer.prototype.getFocusableElements = function() {
		//get all focusable elements inside the drawer
		var allFocusable = this.element.querySelectorAll('[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary');
		this.getFirstVisible(allFocusable);
		this.getLastVisible(allFocusable);
	};

	Drawer.prototype.getFirstVisible = function(elements) {
		//get first visible focusable element inside the drawer
		for(var i = 0; i < elements.length; i++) {
			if( elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length ) {
				this.firstFocusable = elements[i];
				return true;
			}
		}
	};

	Drawer.prototype.getLastVisible = function(elements) {
		//get last visible focusable element inside the drawer
		for(var i = elements.length - 1; i >= 0; i--) {
			if( elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length ) {
				this.lastFocusable = elements[i];
				return true;
			}
		}
	};

	Drawer.prototype.emitDrawerEvents = function(eventName, target) {
		var event = new CustomEvent(eventName, {detail: target});
		this.element.dispatchEvent(event);
	};

	window.Drawer = Drawer;

	//initialize the Drawer objects
	var drawer = document.getElementsByClassName('js-drawer');
	if( drawer.length > 0 ) {
		for( var i = 0; i < drawer.length; i++) {
			(function(i){new Drawer(drawer[i]);})(i);
		}
	}
}());